
import { Component, Vue, Prop } from "vue-property-decorator"

@Component
export default class ApplicantsDraggableListHeader extends Vue {
  @Prop() readonly title!: string
  @Prop() readonly listCount!: number
  @Prop() readonly color!: string
}
